import React from "react";

import { getIconCSSClass } from "../../utils/index";

import ActionPointRenderer from "../../ActionLinks/ActionPointRenderer";

export default function ActionListItem({ index, ...item }) {
  const hasHtmlChar = /<\/?[a-z][\s\S]*>/i.test(item.description);
  return (
    <ActionPointRenderer key={index} {...item}>
      <div className="actionlist__item">
        <div
          className={`view__links__dot ${getIconCSSClass(item.iconKind)}`}
        ></div>
        <div>
          <h3>{item.title}</h3>
          {hasHtmlChar == false ? <p>{item.description}</p> : null}
        </div>
      </div>
    </ActionPointRenderer>
  );
}
